import React from 'react';
import { useCookieConsent } from '../../lib/hooks/useCookieConsent';
import './CookieBanner.css';

interface CookieBannerProps {
  onManage: () => void;
}

export default function CookieBanner({ onManage }: CookieBannerProps) {
  const { consent, dismiss } = useCookieConsent();

  // null means consent hasn't loaded from cookie yet — don't flash the banner
  if (consent === null || consent.shown) return null;

  return (
    <div className="cookie-banner" role="region" aria-label="Cookie notice">
      <div className="cookie-banner__inner">
        <p className="cookie-banner__text">
          We use one cookie to remember that you've seen this notice.
          No analytics, no tracking, no marketing cookies.{' '}
          <a href="/privacy#cookies" className="cookie-banner__link">
            Read the full cookie policy
          </a>{' '}
          or manage preferences.
        </p>
        <div className="cookie-banner__actions">
          <button
            type="button"
            onClick={onManage}
            className="cookie-banner__btn cookie-banner__btn--secondary"
          >
            Cookie settings
          </button>
          <button
            type="button"
            onClick={dismiss}
            className="cookie-banner__btn cookie-banner__btn--primary"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
